/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║  PREMIUM VISITENKARTEN CONFIGURATOR ENGINE                  ║
 * ║  Production-grade state machine for 5-step product config   ║
 * ║  1. Design Source  2. Size  3. Quantity  4. Kontaktangaben  ║
 * ║  5. Zusammenfassung & Warenkorb                             ║
 * ╚══════════════════════════════════════════════════════════════╝
 */
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', init);

    function init() {
        const root = document.getElementById('PvcConfigurator');
        if (!root) return;

        /* ═══ STATE ═══ */
        const config = {
            step: 1,
            maxSteps: 4,
            designSource: 'upload',        // 'upload' | 'design_service' | 'logo_design'
            size: '8.2 × 5.2 cm',
            quantity: '1000',
            designFiles: [],               // Array of File objects
            contactEmail: '',
            contactPhone: '',
            contactNote: '',
            notes: '',
            variantId: null,
            variantPrice: 0,
            designServiceId: root.dataset.designServiceId || null,
            logoDesignId: root.dataset.logoDesignId || null,
            prices: {
                designService: 2950,   // 29.50€ in cents
                logoDesign: 14900      // 149€ in cents
            }
        };

        /* ═══ DOM REFS ═══ */
        const $ = (s) => root.querySelector(s);
        const $$ = (s) => root.querySelectorAll(s);

        const dom = {
            form: $('#PvcForm'),
            title: $('#PvcTitle'),
            hint: $('#PvcHint'),
            dots: $$('.pvc__step-dot'),
            lines: $$('.pvc__step-line'),
            steps: $$('.pvc__step'),
            next: $('#PvcNext'),
            prev: $('#PvcPrev'),
            // Step 1 sub-panels
            uploadPanel: $('#PvcUploadPanel'),
            designPanel: $('#PvcDesignPanel'),
            logoPanel: $('#PvcLogoPanel'),
            fileFront: $('#PvcFileFront'),
            fileBack: $('#PvcFileBack'),
            dropzoneFront: $('#PvcDropzoneFront'),
            dropzoneBack: $('#PvcDropzoneBack'),
            fileRef: $('#PvcRefUpload'),
            dropzoneRef: $('#PvcRefDropzone'),
            // Step 4 fields
            contactEmailInput: $('#PvcContactEmail'),
            contactPhoneInput: $('#PvcContactPhone'),
            contactNoteInput: $('#PvcContactNote'),
            // Step 5 (Now Step 4)
            summary: $('#PvcSummary'),
            priceBase: $('#PvcPriceBase'),
            priceDesignRow: $('#PvcPriceDesignRow'),
            priceDesignAmount: $('#PvcPriceDesignAmount'),
            priceTotal: $('#PvcPriceTotal'),
            confirm: $('#PvcConfirm'),
            // Preview
            cardMockup: $('#PvcCardMockup'),
            previewContainer: $('#PvcPreviewContainer'),
            badgeQty: $('#PvcBadgeQty'),
            // Gallery
            galleryMain: $('#PvcGalleryMain'),
            mainImage: $('#PvcMainImage'),
            galleryThumbs: $$('.pvc__gallery-thumb'),
            // Variant map
            variantMap: JSON.parse($('#PvcVariantMap').textContent),
            // Hidden Inputs
            inputs: {
                id: $('#PvcVariantIdInput'),
                qtyProp: $('#PvcPropQty'),
                sizeProp: $('#PvcPropSize'),
                sourceProp: $('#PvcPropSource'),
                designNoteProp: $('#PvcPropDesignNote'),
                contactEmailProp: $('#PvcPropContactEmail'),
                contactPhoneProp: $('#PvcPropContactPhone'),
                contactNoteProp: $('#PvcPropContactNote')
            }
        };

        const TITLES = [
            'Schritt 1 — Design Quelle',
            'Schritt 2 — Größe',
            'Schritt 3 — Stückzahl',
            'Schritt 4 — Zusammenfassung'
        ];

        const HINTS = [
            'Wählen Sie, wie Sie Ihr Design bereitstellen möchten.',
            'Standardgröße für Premium Visitenkarten.',
            'Wählen Sie die gewünschte Stückzahl.',
            'Überprüfen Sie Ihre Konfiguration und bestellen Sie.'
        ];

        const SOURCE_LABELS = {
            'upload': 'Eigenes Design',
            'design_service': 'Designservice (+29,50 €)',
            'logo_design': 'Logo Design (+149 €)'
        };

        /* ═══ STEPPER ENGINE ═══ */
        function goTo(step) {
            if (step < 1 || step > config.maxSteps) return;
            config.step = step;
            renderStepper();
        }

        function renderStepper() {
            const s = config.step;

            // Title & hint
            dom.title.textContent = TITLES[s - 1];
            dom.hint.textContent = HINTS[s - 1];

            // Dots & lines
            dom.dots.forEach((dot, i) => {
                const n = i + 1;
                dot.classList.toggle('is-active', n === s);
                dot.classList.toggle('is-done', n < s);
            });
            dom.lines.forEach((line, i) => {
                line.classList.toggle('is-done', i + 1 < s);
            });

            // Panels
            dom.steps.forEach(panel => {
                const vis = parseInt(panel.dataset.step) === s;
                panel.classList.toggle('is-visible', vis);
            });

            // Nav
            dom.prev.classList.toggle('is-hidden', s === 1);

            if (s === config.maxSteps) {
                dom.next.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> In den Warenkorb';
                dom.next.classList.remove('pvc__btn--primary');
                dom.next.classList.add('pvc__btn--cart');
            } else {
                dom.next.innerHTML = 'Weiter <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>';
                dom.next.classList.add('pvc__btn--primary');
                dom.next.classList.remove('pvc__btn--cart');
            }

            // Live updates
            if (s === 3) resolveVariant();
            if (s === 4) renderFinalSummary();
        }

        /* ═══ VARIANT RESOLUTION ═══ */
        function resolveVariant() {
            const match = dom.variantMap[config.quantity];
            if (match) {
                config.variantId = match.id;
                config.variantPrice = match.price;
            } else {
                config.variantId = null;
                config.variantPrice = 0;
            }
            // Update qty price displays
            $$('.pvc__qty-card').forEach(card => {
                const qty = card.dataset.qty;
                const v = dom.variantMap[qty];
                const priceEl = card.querySelector('.pvc__qty-price');
                if (v && priceEl) {
                    priceEl.textContent = fmt(v.price);
                }
            });
        }

        /* ═══ PREVIEW ═══ */
        function updatePreview() {
            // Badges
            if (dom.badgeQty) dom.badgeQty.textContent = config.quantity + ' Stk.';

            const containers = [dom.previewContainer].filter(Boolean);
            const files = [dom.fileFront?.files[0], dom.fileBack?.files[0]].filter(Boolean);

            containers.forEach(container => {

                if (files.length > 0) {
                    container.innerHTML = '';
                    files.forEach((file, index) => {
                        const item = document.createElement('div');
                        item.className = 'pvc__preview-item';

                        // Label
                        const label = document.createElement('div');
                        label.className = 'pvc__preview-label';
                        label.style.fontSize = '0.8rem';
                        label.style.padding = '0.2rem 0.5rem';
                        label.textContent = index === 0 ? 'Vorderseite' : 'Rückseite';
                        item.appendChild(label);

                        if (file.type.startsWith('image/')) {
                            const img = document.createElement('img');
                            img.src = URL.createObjectURL(file);
                            img.className = 'pvc__preview-image';
                            item.appendChild(img);
                        } else {
                            // Non-image file placeholder (PDF etc.)
                            const placeholder = document.createElement('div');
                            placeholder.className = 'pvc__preview-placeholder';
                            placeholder.innerHTML = `
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                                </svg>
                                <span style="font-size:10px; font-weight:600; overflow:hidden; text-overflow:ellipsis; width:100%">${file.name}</span>
                            `;
                            item.appendChild(placeholder);
                        }
                        container.appendChild(item);
                    });
                } else {
                    container.innerHTML = `
                        <div class="pvc__preview-placeholder is-empty" style="min-height: 120px;">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="opacity:0.3">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
                            </svg>
                            <span style="font-size:11px; color:var(--pvc-text-muted); opacity:0.6">Kein Design hochgeladen</span>
                        </div>
                    `;
                }
            });
        }

        /* ═══ FINAL SUMMARY ═══ */
        function renderFinalSummary() {
            resolveVariant();

            const rows = [
                { label: 'Design Quelle', value: SOURCE_LABELS[config.designSource] || config.designSource },
                { label: 'Größe', value: config.size },
                { label: 'Stückzahl', value: config.quantity + ' Stk.' }
            ];

            const files = [dom.fileFront?.files[0], dom.fileBack?.files[0]].filter(Boolean);
            if (files.length > 0) {
                rows.push({ label: 'Dateien', value: files.map(f => f.name).join(', ') });
            }

            dom.summary.innerHTML = rows.map(r =>
                `<div class="pvc__summary-row"><span>${r.label}</span><strong>${r.value}</strong></div>`
            ).join('');

            // Prices
            const baseCents = config.variantPrice;
            let extraCents = 0;
            let extraLabel = '';

            if (config.designSource === 'design_service') {
                extraCents = config.prices.designService;
                extraLabel = 'Designservice';
            } else if (config.designSource === 'logo_design') {
                extraCents = config.prices.logoDesign;
                extraLabel = 'Logo Design';
            }

            const totalCents = baseCents + extraCents;

            dom.priceBase.textContent = fmt(baseCents);

            if (extraCents > 0) {
                dom.priceDesignRow.classList.remove('is-hidden');
                dom.priceDesignRow.querySelector('span:first-child').textContent = extraLabel;
                dom.priceDesignAmount.textContent = fmt(extraCents);
            } else {
                dom.priceDesignRow.classList.add('is-hidden');
            }

            dom.priceTotal.textContent = fmt(totalCents);
        }

        function fmt(cents) {
            return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }

        /* ═══ CART SUBMISSION ═══ */
        function addToCart() {
            if (!dom.confirm.checked) {
                shakeButton();
                return;
            }
            if (!config.variantId) {
                alert('Kein passender Variant gefunden. Bitte Stückzahl wählen.');
                return;
            }

            // Sync hidden inputs
            dom.inputs.id.value = config.variantId;
            dom.inputs.qtyProp.value = config.quantity;
            dom.inputs.sizeProp.value = config.size;
            dom.inputs.sourceProp.value = SOURCE_LABELS[config.designSource];

            const noteUpload = root.querySelector('#PvcNoteUpload')?.value || '';
            const noteDesign = root.querySelector('#PvcNoteDesign')?.value || '';
            const noteLogo = root.querySelector('#PvcNoteLogo')?.value || '';
            let designNote = '';
            if (config.designSource === 'upload') designNote = noteUpload;
            else if (config.designSource === 'design_service') designNote = noteDesign;
            else if (config.designSource === 'logo_design') designNote = noteLogo;
            dom.inputs.designNoteProp.value = designNote;

            // 1. Disable all file inputs first
            if (dom.fileFront) dom.fileFront.disabled = true;
            if (dom.fileBack) dom.fileBack.disabled = true;
            if (dom.fileRef) dom.fileRef.disabled = true;

            // 2. Enable only relevant ones
            if (config.designSource === 'upload') {
                if (dom.fileFront) dom.fileFront.disabled = false;
                if (dom.fileBack) dom.fileBack.disabled = false;
            } else if (config.designSource === 'logo_design') {
                if (dom.fileRef) dom.fileRef.disabled = false;
            }

            // Visual feedback
            dom.next.disabled = true;
            dom.next.textContent = 'Wird hinzugefügt…';

            // Submit form natively
            dom.form.submit();
        }

        function shakeButton() {
            dom.next.style.animation = 'none';
            void dom.next.offsetWidth;
            dom.next.style.animation = 'pvcShake 0.4s ease';
        }

        /* ═══ EVENT BINDINGS ═══ */

        // Navigation
        dom.next.addEventListener('click', () => {
            if (config.step < config.maxSteps) goTo(config.step + 1);
            else addToCart();
        });
        dom.prev.addEventListener('click', () => goTo(config.step - 1));

        // Step 1: Design source toggle
        $$('.pvc__choice-card[data-source]').forEach(card => {
            card.addEventListener('click', () => {
                $$('.pvc__choice-card[data-source]').forEach(c => c.classList.remove('is-selected'));
                card.classList.add('is-selected');
                config.designSource = card.dataset.source;

                // Toggle sub-panels
                dom.uploadPanel.classList.toggle('is-hidden', config.designSource !== 'upload');
                dom.designPanel.classList.toggle('is-hidden', config.designSource !== 'design_service');
                dom.logoPanel.classList.toggle('is-hidden', config.designSource !== 'logo_design');
            });
        });

        // Step 3: Quantity selection
        $$('.pvc__qty-card[data-qty]').forEach(card => {
            card.addEventListener('click', () => {
                $$('.pvc__qty-card[data-qty]').forEach(c => c.classList.remove('is-selected'));
                card.classList.add('is-selected');
                config.quantity = card.dataset.qty;
                resolveVariant();
                updatePreview();
            });
        });

        // Product gallery logic
        function handleFileChange(input, dropzone, label) {
            if (!input) return;
            input.addEventListener('change', e => {
                const file = e.target.files[0];
                if (!file) {
                    if (label) label.textContent = input.id === 'PvcFileFront' ? 'Frontseite' : 'Rückseite';
                    updatePreview();
                    return;
                }

                // 25MB Limit Check
                if (file.size > 25 * 1024 * 1024) {
                    alert('Datei zu groß! Die maximale Dateigröße beträgt 25 MB.');
                    input.value = '';
                    if (label) label.textContent = input.id === 'PvcFileFront' ? 'Frontseite' : 'Rückseite';
                    updatePreview();
                    return;
                }

                if (label) label.textContent = file.name;
                updatePreview();
            });

            if (dropzone) {
                dropzone.addEventListener('dragover', e => { e.preventDefault(); dropzone.classList.add('is-dragover'); });
                dropzone.addEventListener('dragleave', () => dropzone.classList.remove('is-dragover'));
                dropzone.addEventListener('drop', e => {
                    e.preventDefault();
                    dropzone.classList.remove('is-dragover');
                    if (e.dataTransfer.files.length) {
                        input.files = e.dataTransfer.files;
                        input.dispatchEvent(new Event('change'));
                    }
                });
            }
        }

        handleFileChange(dom.fileFront, dom.dropzoneFront, dom.dropzoneFront?.querySelector('.pvc__dropzone-label span'));
        handleFileChange(dom.fileBack, dom.dropzoneBack, dom.dropzoneBack?.querySelector('.pvc__dropzone-label span'));
        handleFileChange(dom.fileRef, dom.dropzoneRef, dom.dropzoneRef?.querySelector('.pvc__dropzone-label span'));

        // Product gallery logic
        dom.galleryThumbs.forEach(thumb => {
            thumb.addEventListener('click', () => {
                dom.galleryThumbs.forEach(t => t.classList.remove('is-active'));
                thumb.classList.add('is-active');
                const newUrl = thumb.dataset.imageUrl;
                if (newUrl && dom.mainImage) {
                    dom.mainImage.src = newUrl;
                }
            });
        });

        /* ═══ INIT ═══ */
        resolveVariant();
        updatePreview();
        renderStepper();
    }
})();
